import component from './header.vue'

export default component
